var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSaveSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C49658D3-7693-4A47-B981-4CB5E0C3BBED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uzdotie-jaut\\u0101jumi",
    transform: "translate(-346.000000, -1158.000000)",
    fill: "#009933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-1",
    transform: "translate(260.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(30.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item-6",
    transform: "translate(0.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-with-Icon",
    transform: "translate(56.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M11.5547002,4.16794971 C11.0951715,3.86159725 10.4743022,3.98577112 10.1679497,4.4452998 L6.844,9.429 L5.70710678,8.29289322 C5.31658249,7.90236893 4.68341751,7.90236893 4.29289322,8.29289322 C3.90236893,8.68341751 3.90236893,9.31658249 4.29289322,9.70710678 L6.29289322,11.7071068 C6.73911042,12.153324 7.48200872,12.0797626 7.83205029,11.5547002 L11.8320503,5.5547002 C12.1384028,5.09517151 12.0142289,4.47430216 11.5547002,4.16794971 Z",
    id: "icon"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveSmall);
export default __webpack_public_path__ + "static/media/ic-save-small.9da2fc0a18e2909011fbf74167d8856a.svg";
export { ForwardRef as ReactComponent };